import { days } from "./utils";
import moment from "moment";

export class Validator {
  constructor() {
    if (Validator._instance) {
      return Validator._instance;
    }
    this.isValid = true;
    this.errors = {};
    this.listeners = [];
    this.snapshot = null;
    // console.log("Validator init");
    Validator._instance = this;
  }

  addListener(listener) {
    this.listeners.push(listener);
    console.log("Validator pushed listener", this.listeners.length);
  }

  static instance() {
    return new Validator();
  }

  trigger() {
    if (this.snapshot) this.validate(this.snapshot);
  }

  // isValid() {
  //   return this.formState.isValid;
  // }

  clean(data) {
    // console.log("Validator clean start", data);
    const obj = {};
    for (let day of days) {
      if (data[day.name]) obj[day.name] = data[day.name];
    }

    // console.log("Validator clean end", data, obj);
    return obj;
  }

  skeleton(source, isArray) {
    let o = Array.isArray(source) ? [] : {};
    for (let key in source) {
      if (source.hasOwnProperty(key)) {
        let t = typeof source[key];
        o[key] =
          t == "object"
            ? this.skeleton(source[key])
            : { string: "", number: 0, boolean: false }[t];
      }
    }
    return o;
  }

  async validate(input, callback) {
    // console.log("Validator Input", input);
    const data = this.clean(input);
    this.snapshot = { ...data };
    const errors = this.skeleton(data, false);
    let isValid = true;
    for (let d of Object.keys(data)) {
      const slots = data[d].slots;
      let dayTotalDuration = 0;
      if ( slots !== null && slots !== undefined) {
      // console.log("slots data ", slots);
      for (let slotIndex = 0; slotIndex < slots.length; ++slotIndex) {
        const slot = slots[slotIndex];
        // console.log("SLOT (day,index)=>", d, slotIndex);
        let nextSlot;
        let prevSlot;
        // nextSlot = data[d].slots[slotIndex + 1];
        prevSlot = data[d].slots[slotIndex - 1];
        // console.table()

        // console.log("nextSlot nextSlot",nextSlot);
        // console.log("prevSlot prevSlot",prevSlot);
        // console.log("slot slot",slot);

        let previousEndSlot;
        if (prevSlot !== undefined && prevSlot !== null) {
          previousEndSlot = prevSlot.end;
        }

        const start = slot.start;
        const end = slot.end;
        const startTime = moment(start, "HH:mma"); //todays date
        const endTime = moment(end, "HH:mma");

        const difference = moment.duration(endTime.diff(startTime));
        // console.log("diff",difference);

        let hours = parseInt(difference.asHours());
        // console.log("hours",hours);

        dayTotalDuration += hours;
        // console.log("dayTotalDuration",dayTotalDuration);

        if (dayTotalDuration > 24) {
          isValid = false;
        }

        const startIsAfter = moment(start, "HH:mma").isSameOrAfter(
          moment(end, "HH:mma")
        );
        const endIsBefore = moment(end, "HH:mma").isSameOrBefore(
          moment(start, "HH:mma")
        );
        const nextStartIsBeforePreviousEnd = moment(
          start,
          "HH:mma"
        ).isSameOrBefore(moment(previousEndSlot, "HH:mma"));

        if (startIsAfter) {
          errors[d].slots[slotIndex].start = "Start is after end";
          isValid = false;
        }
        if (endIsBefore) {
          errors[d].slots[slotIndex].end = "End is before start";
          isValid = false;
        }
        if (nextStartIsBeforePreviousEnd) {
          errors[d].slots[slotIndex].start =
            "Next Start is before Previous End";
          isValid = false;
        }
      }
    }
    }
    this.errors = errors;
    this.isValid = isValid;
    for (let i = 0; i < this.listeners.length; i++) {
      let listener = this.listeners[i];
      if (listener) listener(this.isValid, this.errors);
      else this.listeners.splice(i, 1);
    }
    console.log("Validator validate", this.isValid);
    if (callback) callback({ isValid: this.isValid, errors: this.errors });
    return { errors, isValid };
  }
}
